<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>

        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                      {title: 'You are here : '},
                        {
                          title: 'Dashboard',
                          url: '/#/dashboard/Trainee/traineeDashboard'
                        },
                        {
                          title: '',
                          url: '/#/dashboard/Trainee/traineeDashboard'
                        },
                        {
                          title: 'Knowledge Base',
                          active: true
                        }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">KNOWLEDGE BASE FORM</h3>
            </div>

            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Event Information</h6>
              <div class="row col-sm-12">
                <label class="col-sm-1 font-weight-bold">Title:</label>
                <div class="col-sm-11">Global Training for prevention techniques against drug</div>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Start Date:</label>
                <p class="col-sm-2" style="padding:0px 0px 0px 15px">22-7-2019</p>

                <label class="col-sm-2 font-weight-bold p-0">End Date:</label>
                <p class="col-sm-4 p-0">27-7-2019</p>
              </div>
            </div>
            <div class="row mt-5">
              <a href="#" class="pr-3 col-sm-4">
                <vs-radio v-model="radios1" vs-value="Pre Training Form">Pre Training</vs-radio>
              </a>
              <a href="#" class="pr-3 col-sm-4">
                <vs-radio v-model="radios1" vs-value="In Training Form">In Training</vs-radio>
              </a>
              <a href="#" class="pr-3 col-sm-4">
                <vs-radio v-model="radios1" vs-value="Reference Material Form">Reference Material</vs-radio>
              </a>
            </div>
            <div class="modelx mt-3">
              <!-- Pre Training -->
              <div class="form-group form-row mb-0">
                <h6 class="sub-frm-title">
                  <template v-if="radios1 === 'Pre Training Form'">Pre Training Form</template>
                  <template v-if="radios1 === 'In Training Form'">In Training Form</template>
                  <template v-if="radios1 === 'Reference Material Form'">Reference Material Form</template>
                </h6>
                <div class="row p-2">
                  <div class="table-responsive-sm" style="width:100%">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Title</th>
                          <th scope="col">File Type</th>
                          <th scope="col">Upload</th>
                          <th scope="col">Link (Optional)</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(item,index) in accademicArr">
                          <tr v-bind:key="index">
                            <td>
                              <div>
                                <input
                                  style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                  type="text"
                                  class="form-control"
                                  id="inputtext"
                                  placeholder
                                />
                              </div>
                            </td>
                            <td>
                              <div>
                                <vs-select v-model="select11">
                                  <vs-select-item
                                    :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in pretrainingmanualArr"
                                  />
                                </vs-select>
                              </div>
                            </td>
                            <td>
                              <div>
                                <b-form-file
                                  v-model="file"
                                  :state="Boolean(file)"
                                  placeholder="Choose a file..."
                                  drop-placeholder="Drop file here..."
                                ></b-form-file>
                              </div>
                            </td>
                            <td>
                              <div>
                                <input
                                  style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)"
                                  type="text"
                                  class="form-control"
                                  id="inputtext"
                                  placeholder
                                />
                              </div>
                            </td>
                            <td style="vertical-align: middle;">
                              <div>
                                <vs-icon
                                  icon="add_box"
                                  style="color:#007bff;font-size:16px;cursor: pointer;"
                                ></vs-icon>
                                <vs-icon icon="edit" color="warning" style="font-size:16px"></vs-icon>
                                <vs-icon
                                  icon="delete_forever"
                                  style="color:#ff0000c7;font-size:16px;cursor: pointer;"
                                ></vs-icon>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row justify-content-end mr-0">
                <b-button class="save-btn d-flex justify-content-end" variant="primary">Save</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    isSidebar: false,
    file: null,
    accademicArr: 1,
    radios1: "Pre Training Form",
    popupActivo: false,
    activeItem: 0,
    search: "",
    isForm: true,
    isFormData: false,
    selected: "",
    subprogramSelected: "",
    subprogramsettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 3,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    donerSelected: "",
    donersettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    colorx: "#1db952",
    select1: 1,
    pretrainingmanualArr: [
      { text: "PDF", value: 1 },
      { text: "Word", value: 2 },
      { text: "PPT", value: 3 },
      { text: "Video", value: 4 },
      { text: "Html", value: 5 }
    ]
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    // this.totalRows = this.items.length;
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded, consectetur"
      });
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.was-validated .custom-file-input:invalid ~ .custom-file-label,
.custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #cecece;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.add-btn {
  font-size: 25px;
  color: rgba(7, 167, 225, 0.61);
  cursor: pointer;
}
.delete-btn {
  font-size: 25px;
  color: rgba(255, 0, 0, 0.78);
  cursor: pointer;
}

th {
  border-bottom: none !important;
}
</style>


